const stats = [
  {
    icon: 'ri-star-fill',
    value: '5-Star',
    label: 'Google Rated',
    accent: true,
  },
  {
    icon: 'ri-shield-star-fill',
    value: 'Licensed',
    label: '& Fully Insured',
    accent: false,
  },
  {
    icon: 'ri-map-pin-2-fill',
    value: '6 Cities',
    label: 'Served in Florida',
    accent: true,
  },
  {
    icon: 'ri-graduation-cap-fill',
    value: 'Degree',
    label: 'in Landscaping',
    accent: false,
  },
  {
    icon: 'ri-thumb-up-fill',
    value: '100%',
    label: 'Satisfaction Guaranteed',
    accent: true,
  },
];

export default function TrustBar() {
  return (
    <section className="bg-charcoal border-b border-white/8 py-0">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 divide-x divide-white/8">
          {stats.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 px-8 py-6 group hover:bg-white/4 transition-colors"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 ${
                item.accent ? 'bg-gold/15 text-gold' : 'bg-forest/20 text-forest-light'
              }`}>
                <i className={`${item.icon} text-base`}></i>
              </div>
              <div>
                <p className="text-white font-semibold text-sm leading-none mb-0.5">{item.value}</p>
                <p className="text-white/45 text-xs">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
